import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4895ce73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalTickets",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-4 p-3 align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h1", { class: "titulo" }, "Detalhes do Ticket")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_6 = {
  class: "modal-body d-flex flex-column p-5 gap-5",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_7 = { class: "card p-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo" }, "Informações do cliente", -1))
const _hoisted_9 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_10 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CNPJ:", -1))
const _hoisted_12 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loja (Nome Fantasia):", -1))
const _hoisted_14 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerente:", -1))
const _hoisted_16 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Solicitante:", -1))
const _hoisted_18 = { class: "d-flex flex-column gap-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Contato:", -1))
const _hoisted_20 = { class: "d-flex flex-column gap-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automação:", -1))
const _hoisted_22 = { class: "d-flex flex-column gap-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Possui Conecta?:", -1))
const _hoisted_24 = { class: "card p-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitulo" }, "Informações do Problema", -1))
const _hoisted_26 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_27 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resumo:", -1))
const _hoisted_29 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_31 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Data do reporte:", -1))
const _hoisted_33 = { class: "d-flex flex-column gap-1 input-info" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Categoria:", -1))
const _hoisted_35 = {
  class: "d-flex flex-column gap-1",
  style: {"width":"40%"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descrição do problema:", -1))
const _hoisted_37 = {
  class: "d-flex flex-column gap-1",
  style: {"width":"40%"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resolução do problema:", -1))
const _hoisted_39 = { style: {"max-height":"15rem","overflow-y":"auto","background-color":"#f3f3f3"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Comments = _resolveComponent("Comments")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _withDirectives(_createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.cnpj,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ticket.cnpj) = $event)),
                        placeholder: "Digite...",
                        maxlength: "18"
                      }, null, 8, ["modelValue"]), [
                        [_directive_maska, { mask:'##.###.###/####-##' }]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.store_name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ticket.store_name) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.store_manager,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ticket.store_manager) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.solicitante,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ticket.solicitante) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.store_contact,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ticket.store_contact) = $event)),
                        clearable: "",
                        placeholder: "Digite...",
                        maxlength: "15"
                      }, null, 8, ["modelValue"]), [
                        [_directive_maska, { mask:'(##) #####-####' }]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.erp,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ticket.erp) = $event)),
                        placeholder: "Selecione"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ticket.possui_conecta,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ticket.possui_conecta) = $event)),
                        placeholder: "Selecione"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: 'sim',
                            value: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: 'não',
                            value: 0
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.title,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ticket.title) = $event)),
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.id_status,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ticket.id_status) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.report_date,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ticket.report_date) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.id_category,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ticket.id_category) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.description,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ticket.description) = $event)),
                        rows: 4,
                        type: "textarea",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ticket.resolution,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ticket.resolution) = $event)),
                        rows: 4,
                        type: "textarea",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_Comments, {
                arrayComments: _ctx.arrayComments,
                onlyRead: true
              }, null, 8, ["arrayComments"])
            ])
          ]),
          _hoisted_40
        ])
      ])
    ])
  ]))
}